import Layout from '@/layout'
const warrantyRouter = {
  path: '/warranty_old',
  component: Layout,
  name: 'warranty',
  meta: {
    title: '旧电子质保管理',
    icon: 'el-icon-camera-solid',
    roles: ['root']
  },
  children: [
    {
      path: 'create',
      name: 'WarrantyOldCreate',
      component: () => import('@/views/warranty_old/create'),
      meta: { title: '旧系统质保创建', icon: 'el-icon-plus', noCache: true }
    },
    {
      path: 'update',
      name: 'WarrantyOldUpdate',
      component: () => import('@/views/warranty_old/update'),
      meta: { title: '旧系统质保更新', icon: 'el-icon-plus', noCache: true },
      hidden: true
    },
    {
      path: 'table',
      name: 'WarrantyOldTable',
      component: () => import('@/views/warranty_old/table'),
      meta: { title: '旧系统质保查询', icon: 'el-icon-search', noCache: false }
    }
  ]
}
export default warrantyRouter
